import React from "react";
import { getUser } from "../../state/User";
import { signOut } from "../../apis/firebase";
import { Link, useHistory } from "react-router-dom";
import { trackEvent } from "../helpers";

export default function Navigation() {
  const user = getUser();
  const history = useHistory();

  return (
    <>
      <nav className="main">
        <div>
          <Link to="/" className="logo mr1">
            <img src="/assets/img/logo_50x50.png" alt="Contempas" />
          </Link>
          <button
            onClick={() => {
              trackEvent("main-nav-campaigns");
              history.push("/");
            }}
          >
            Campaigns
          </button>
          <button
            onClick={() => {
              trackEvent("main-nav-timeline");
              history.push("/timeline");
            }}
          >
            Timeline
          </button>
          <button
            onClick={() => {
              trackEvent("main-nav-destinations");
              history.push("/destinations");
            }}
          >
            Destinations
          </button>
          <button
            onClick={() => {
              trackEvent("main-nav-reports");
              history.push("/reports");
            }}
          >
            Reports
          </button>
        </div>
        <div>
          {user && <span className="profile ib mr1">{user.email}</span>}
          <button onClick={() => signOut()}>Sign out</button>
        </div>
      </nav>
      {user?.demo && (
        <div className="mb1 p1 tac" style={{ fontSize: "0.73em" }}>
          ⚠️ This is a demo version. You may see updates done by other people.
          Sign out and create your own account.
        </div>
      )}
    </>
  );
}
